import { showToast } from "@/lib/utils/toast";
import { dataEntryService } from "../services/data-entry.services";
import { disclosureStore } from "../stores/disclosure.store";
import { prefillStore } from "../stores/prefill.store";
import { bulkCreateDataEntries } from "./entry.ops";

export const loadPrefillSuggestions = async () => {
  const { activeDisclosure } = disclosureStore;
  if (!activeDisclosure?._id) return;

  prefillStore.reset();
  const { setLoading, setSuggestions, setShowBanner } = prefillStore;

  setLoading(true);
  try {
    const data = await dataEntryService.getPrefillSuggestions(
      activeDisclosure._id,
    );
    const matches = data?.matches ?? [];
    setSuggestions(matches);
    if (matches.length > 0) setShowBanner(true);
  } catch {
    // prefill is non-critical, fail silently
  } finally {
    setLoading(false);
  }
};

export const applyPrefillSuggestions = async () => {
  const { activeDisclosure } = disclosureStore;
  const { suggestions } = prefillStore;

  if (!activeDisclosure?._id || !suggestions.length) return false;

  const entries = suggestions.flatMap((match) =>
    match.entries.map((entry) => ({
      orgId: entry.orgId,
      disclosureId: activeDisclosure._id,
      label: entry.label,
      value: entry.value,
      unit: entry.unit,
      reportingDate: entry.reportingDate,
      entryDate: entry.entryDate,
      prefillFrom: match.sourceDisclosureId,
      ...(entry.subEntryGroupIndex != null && {
        subEntryGroupIndex: entry.subEntryGroupIndex,
      }),
    })),
  );

  if (!entries.length) return false;

  const success = await bulkCreateDataEntries(entries);

  if (success) {
    showToast.success(
      `Applied ${entries.length} entry(s) from other frameworks`,
    );
    prefillStore.reset();
  }

  return success;
};
